import { AxiosInstance } from "axios"
import { OrdersPOSType } from "./pages/posTypes"

export enum SupportReportsOrdersPPOSQuery {
    ORDERS_POS_FOR_SUPPORT = "orders-pos-for-support",
}

type SupportOrdersPOSParams = Readonly<{
    orderId?: string
    startDate?: string
    endDate?: string
    merchantId?: string
    merchantIds?: string
    customerId?: string
    userGroupId?: string
    email?: string
    paymentMethods?: string
    creditCardLast4?: string
    shopIds?: string
}>

export type SupportOrdersPOSResponse = Readonly<{
    orders: OrdersPOSType[]
}>

export async function fetchSupportOrdersPOS(
    params: SupportOrdersPOSParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SupportOrdersPOSResponse> {
    const url = "/accounting/pos"
    const { data } = await axios.get(url, {
        params,
        signal,
    })

    return data
}
